import { useQuery } from "@tanstack/react-query";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { getGenericMiscellaneous } from "../lib/api";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function dateConvert(date) {
  return date.toISOString().replace(/\.\d+/, "");
}

 
  export const useAppointmentsMiscellaneous = () => useQuery({queryKey:['appointmentMisc'],queryFn:() => getGenericMiscellaneous()})
